import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const Home = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            id:'How',
            icon:'How_light',
            label: 'How to access OLE',
            path:'/how-to-access-ole',
        },
        {
            id:'Dashboard',
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/dashboard'
        },
        {
            id:'Course',
            icon:'Course_light',
            label: 'Course Page',
            path:'/course-page',
        },
        {
            id:'Attendance',
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking-attendance'
        },
        {
            id:'Assignment',
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            id:'Zoom',
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom-recording',
        },
        {
            id:'Teaching',
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching-tools',
        }
    ]


    return (
        <div className='Home'>
            <Header/>
            <div style={{display:'flex',justifyContent:'center',}}>
                <div className={'HomeTitleContain'} >
                    
                    <span className={'HomeTitleFirst'}>Getting started with</span>
                    <br/>
                    <span className={'HomeTitleSecond'}>Online Learning Environment (OLE)</span>
                    <br/>
                    <span className={'HomeTitleThird'}>for full-time teaching staff</span>
                </div>
            </div>
            <div className={'HomeSeparate'} >
                <img src={Image.Down}/>
            </div>
            <div className={'HomeMainContent'}>
                <div className={'HomeMainContentLeft'}>
                    <div className={'HomeMainContentLeftTop'}>
                        <p>Welcome on board!</p>
                        <span>
                        As a newly joined teaching staff member of HKMU, you will receive teaching support from various platforms provided by the Office for Advancement of Learning and Teaching (ALTO). One of them is the Online Learning Environment (OLE). This guide will focus on some of the platform’s important features which you should know about.
                        </span>
                        <br/><br/>
                        <span>
                            We hope that this guide will familiarise you with the OLE and enable you to provide effective teaching to students.
                        </span>
                        <img src={Image.Welcome} style={{width:'100%'}}/>
                    </div>
                    <div className={'HomeMainContentLeftBottom'}/>
                    </div>
                    
                    
                
                <div className={'HomeMainContentRight'}>
                    <p>
                    <div  className={'HomeMainContentRightTop'}>
                        {
                            rightIconAry.map((item,index)=>{
                                
                                return (
                                    <div className='HomeMainContentRightIcon' onClick={()=>{navigate(item.path)}} key={index}>
                                            <img className={item.id+'Icon'} src={Image[item.icon]} />
                                        <div>
                                            <span>{item.label} </span>
                                        </div>
                                    </div>
                                )
                            })

                        }
                    </div>
                    </p>
                </div>
            </div>
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default Home;
export default connect(mapStateToProps)(Home);